import { useEffect, useState } from 'react';
import { get } from '../api';
import { Link } from 'react-router-dom';
import DataTable from '../components/data-table/data-table';

export default function Games2Page() {
  const [games, setGames] = useState([]);

  useEffect(() => {
    get('games')
      .then(setGames)
      .catch(() => {});
  }, []);

  return (
    <div>
      <DataTable
        columns={[
          {
            name: 'id',
            label: 'ID',
          },
          {
            label: 'Players',
            render: ({ row }) => row.slots.length,
          },
          {
            name: '',
            label: '',
            render: ({ row }: any) => <Link to={`/games/${row.id}`}>Join</Link>,
          },
        ]}
        data={games}
      />
    </div>
  );
}
